module.exports = __webpack_public_path__ + "static/media/BA.f733a6a7.png";